// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.glow[data-v-6f07a7ac] {\n  -webkit-box-shadow: 0px 0px 8px 6px #5a5;\n          box-shadow: 0px 0px 8px 6px #5a5;\n}\n.bottom-right[data-v-6f07a7ac] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
